import {
  isAccountTeamRole,
  isRole,
  ROLES,
} from "../../../Utils/Constants/RoleConstants";

export const EXPLORE_ALL_RELATIONSHIPS_ENABLED = false;

export const EXPLORE_ALL_RELATIONSHIPS_COMING_SOON_MSG =
  "Coming soon — Explore All Relationships will be available in an upcoming release.";

/** My Relationship — account team, sponsors, executives, and C-level. */
export function canViewMyRelationshipsTab(role) {
  if (isAccountTeamRole(role)) return true;
  if (isRole(role, ROLES.EXECUTIVE_SPONSOR)) return true;
  if (isRole(role, ROLES.EXECUTIVE)) return true;
  if (isRole(role, ROLES.C_LEVEL)) return true;
  return false;
}

/** My Portfolio toggle — users with their own portfolio (not admins or sponsor leads). */
export function canViewMyPortfolioToggle(role) {
  if (isAccountTeamRole(role)) return true;
  if (isRole(role, ROLES.EXECUTIVE_SPONSOR)) return true;
  if (isRole(role, ROLES.EXECUTIVE)) return true;
  if (isRole(role, ROLES.C_LEVEL)) return true;
  return false;
}
